import React from 'react';
import AgentOpsOverviewHelp from './AgentOpsOverviewHelp';
import RunsHelp from './RunsHelp';
import ToolsHelp from './ToolsHelp';
import APMHelp from './APMHelp';
import MemoryHelp from './MemoryHelp';
import SafetyHelp from './SafetyHelp';
import IncidentsHelp from './IncidentsHelp';

interface AgentOpsHelpProps {
  activeTab?: string;
}

/**
 * AgentOps Help - Context-aware help content switcher
 */
const AgentOpsHelp: React.FC<AgentOpsHelpProps> = ({ activeTab }) => {
  switch (activeTab) {
    case 'overview':
      return <AgentOpsOverviewHelp />;
    case 'runs':
      return <RunsHelp />;
    case 'tools':
      return <ToolsHelp />;
    case 'apm':
      return <APMHelp />;
    case 'memory':
      return <MemoryHelp />;
    case 'safety':
      return <SafetyHelp />;
    case 'incidents':
      return <IncidentsHelp />;
    default:
      return <AgentOpsOverviewHelp />;
  }
};

export default AgentOpsHelp;
